export class TableviewCustomOption {
  name: string;
  text: string;
  value: boolean;
  desc?: string;

  // when option is set to true, switch off other options
  switchOffNames?: string[];
}
